import makeFetchCall from './makeFetchCall';
import { getUploadedImagePath } from '@nutastic/nutastic-react-app';
import { buildAuthorCredit } from '../refactor/nu-player/utils/buildTracks.mjs';

const buildBroadcastTracks = (broadcastSchedule, coverImage) => {
    return (broadcastSchedule || []).map(track => {
        const {
            title,
            field_2: audioFile,
            artist: artistObj = {},
            artists = [],
            field_6: artistOverride,
            blockIndex
        } = track;
        return {
            title: title,
            src: getUploadedImagePath(audioFile),
            author: artistOverride ? artistOverride : buildAuthorCredit(artistObj, artists),
            thumbnail: getUploadedImagePath(coverImage),
            blockIndex: blockIndex
        }
    })
};

const getBroadcastData = async ({ musicProjectId }, onComplete, onFail) => {
    try {
        const broadcastData = await makeFetchCall(`/api/start-broadcast/${musicProjectId}`);
        if(broadcastData) {
            const { broadcastSchedule, targetTrackIndex, trackLandingTime, image, thumbnail } = broadcastData;
            const tracksToLoad = buildBroadcastTracks(broadcastSchedule, thumbnail || image);
            onComplete && onComplete({
                broadcastSchedule,
                targetTrackIndex,
                trackLandingTime,
                tracksToLoad
            });
        } else {
            onFail && onFail('No broadcast data found...');
        }
    } catch (e) {
        console.error('Failed to get broadcast data', e);
        onFail && onFail('Failed to get broadcast data');
    }

};

export default getBroadcastData;
